exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container[data-v-e316ab36]{margin:auto;width:80%}.card-row[data-v-e316ab36]{width:100%;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.card-first-row[data-v-e316ab36]{width:50%}.sc-thanks-card[data-v-e316ab36]{width:100%;-webkit-box-shadow:0 1px 1px 1px hsla(0,0%,86.3%,.4);box-shadow:0 1px 1px 1px hsla(0,0%,86.3%,.4)}.sc-thanks-main-page[data-v-e316ab36]{width:200px;margin:30px auto}.sc-thanks-bank-data-container[data-v-e316ab36]{color:#2c3e50;width:75%}.sc-thanks-bank-data-hr[data-v-e316ab36]{margin:10px 0}", ""]);

// exports
